import { useEffect, useState } from 'react';

/**
 * Renders a phone number that's protected from bot crawlers.
 * The number is obfuscated in the source code and only assembled via JavaScript,
 * which most bots don't execute.
 */
export const ObfuscatedPhone = ({ className = '' }) => {
  const [phone, setPhone] = useState('');
  
  useEffect(() => {
    // Obfuscated parts - bots can't easily parse this
    const p1 = String.fromCharCode(53, 49, 52); // "514"
    const p2 = String.fromCharCode(50, 57, 49); // "291"
    const p3 = String.fromCharCode(51, 55, 51, 55); // "3737"
    
    // Assemble after a tiny delay to further confuse crawlers
    const timer = setTimeout(() => {
      setPhone(`(${p1}) ${p2}-${p3}`);
    }, 10);
    
    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    // Create the tel: link dynamically
    const p1 = String.fromCharCode(53, 49, 52);
    const p2 = String.fromCharCode(50, 57, 49);
    const p3 = String.fromCharCode(51, 55, 51, 55);
    window.location.href = `tel:+1${p1}${p2}${p3}`;
  };

  return (
    <button 
      onClick={handleClick}
      className={`hover:text-primary transition-colors cursor-pointer text-left ${className}`}
      aria-label="Call us"
      data-testid="phone-number"
    >
      {phone || '(•••) •••-••••'}
    </button>
  );
};
